var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultSetup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2376 19.5491C10.914 19.6376 10.6061 19.7233 10.3105 19.8065L12.0238 22.8433H20.3444L17.0111 16.9355C15.6104 17.8131 13.7913 18.6781 11.3384 19.5179L11.2376 19.5491Z",
    fill: "#F1962F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7146 4.00459L8.32023 1.53348H0L3.7448 8.17101C5.34147 6.50879 7.38844 5.08227 9.7146 4.00491V4.00459Z",
    fill: "#F1962F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.291135 21.9367C0.291135 21.9367 0.592383 16.4512 2.97652 12.488C4.97686 8.31343 10.2651 4.81788 16.2658 3.81331C16.2658 3.81331 21.3076 2.64361 22.8693 1.73545C22.8693 1.73545 24.568 0.634452 23.8007 3.19411C23.8007 3.19411 22.7832 5.67215 19.646 7.2808C18.9064 7.65264 18.3565 7.73583 18.4728 8.44325C18.6827 9.16202 19.8823 8.61562 20.0468 8.53306C20.332 8.29704 23.1128 7.53478 21.26 10.1921C19.3967 12.9443 18.2658 15.441 11.0321 17.9181C6.20958 19.239 4.29149 19.9824 1.49676 22.5143C0.0992323 23.5072 0.291135 21.9367 0.291135 21.9367Z",
    fill: "#F1962F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSetup);
export default __webpack_public_path__ + "static/media/default-setup.01afbad7389bffff76731e36f908c2d8.svg";
export { ForwardRef as ReactComponent };